/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import SettingSensorView from '../../view/pages/room/SettingSensorView'
import SettingSensorStore from '../../store/room/SettingSensorStore'
import RoomAction from '../../action/room'
import RoomStore from '../../store/room/RoomStore'

class SettingSensorContainer extends Component {
  static getStores() {
    return [RoomStore, SettingSensorStore]
  }

  static calculateState(prevState, props) {
    return {
      room: RoomStore.getState(),
      settingSensor: SettingSensorStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    const id = this.state.match.params.id

    // TODO id がない場合はエラー
    if (id) {
      RoomAction.fetchOne(id)
    }
  }

  render() {
    return SettingSensorView(this.state)
  }
}

export default withRouter(Container.create(SettingSensorContainer, { withProps: true }))
